import PropTypes from "prop-types";

// material-ui
import { useTheme } from "@mui/material/styles";
import { Box, Drawer, Divider, useMediaQuery } from "@mui/material";

// third-party
import PerfectScrollbar from "react-perfect-scrollbar";

// project imports
import MenuList from "./components/MenuList/MenuList";

import FIVBLogo from "assets/images/icons/fivb-logo-sidemenu.svg";
import ProfileSection from "../ProfileSection/ProfileSection";
import "assets/styles.css";

const drawerWidth = "20%";
const MinSideBar = `/icons/keyboard_tab_rtl.svg`;

const ExpandSideBar = `/icons/keyboard_tab_rtl_expand.svg`;

// ==============================|| SIDEBAR DRAWER ||============================== //

const Sidebar = ({ drawerOpen, handleLeftDrawerToggle }) => {
  const theme = useTheme();
  const matchUpMd = useMediaQuery(theme.breakpoints.up("md"));
  const minimizedWidth = 80;

  const drawer = (
    <PerfectScrollbar
      component="div"
      style={{
        height: !matchUpMd ? "calc(100vh - 56px)" : "calc(100vh - 88px)",
        paddingLeft: "13px",
        paddingRight: "13px",
      }}
    >
      <div className={drawerOpen ? "SideBarDrawerScroll" : "SideBarDrawerMinimizedScroll"}>
        <img
          style={{ width: "64px", height: "23px" }}
          src={FIVBLogo}
          alt={"FIVB Logo"}
        />
        <button
          onClick={handleLeftDrawerToggle}
          style={{ border: "none", background: "none", padding: "0" }}
        >
          <img
            style={{ width: "24px", height: "24px", cursor: "pointer" }}
            src={drawerOpen ? MinSideBar : ExpandSideBar}
            alt={drawerOpen ? "Minimize Sidebar" : "Expand Sidebar"}
          />
        </button>
      </div>

      <MenuList isMinimized={!drawerOpen} />
      <Divider
        sx={{
          mt: 0.25,
          mb: 1.25,
          color: "var(--custom-accent-7, #E3E7E9)",
        }}
      />
      <ProfileSection isMinimized={!drawerOpen} />
    </PerfectScrollbar>
  );


  return (
    <Box
      component="nav"
      sx={{
        flexShrink: { md: 0 },
        width: drawerOpen ? drawerWidth : minimizedWidth,
      }}
      aria-label="mailbox folders"
    >
      <Drawer
        variant="permanent"
        sx={{
          "& .MuiDrawer-paper": {
            width: drawerOpen ? drawerWidth : minimizedWidth,
            background: "var(--custom-accent-1, #261E7F)",
            color: theme.palette.text.primary,
            borderRight: "none",
            paddingTop: matchUpMd ? "48px" : "48px",
          },
        }}
        open
      >
        {drawer}
      </Drawer>
    </Box>
  );
};

Sidebar.propTypes = {
  drawerOpen: PropTypes.bool,

  window: PropTypes.object,
};

export default Sidebar;
